import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import api from "@/lib/api";

export default function VipBanner() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/soiree-vip").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const banner = data?.banner;
  if (!banner?.enabled) return null;

  // Repli sur l'affiche officielle embarquée dans le build (/soiree-vip.png) :
  // fonctionne immédiatement en production, sans dépendre d'un téléversement.
  const imageUrl = banner.image_url || "/soiree-vip.png";
  const hasMedia = !!(banner.video_url || imageUrl);

  return (
    <section className="relative overflow-hidden border-y border-gold/25" data-testid="vip-banner">
      <Link to="/soiree-vip" className="group relative block" data-testid="vip-banner-link">
        <div className="relative h-[380px] md:h-[480px]">
          {banner.video_url ? (
            <video
              src={banner.video_url}
              className="h-full w-full object-cover"
              autoPlay
              muted
              loop
              playsInline
              data-testid="vip-banner-video"
            />
          ) : imageUrl ? (
            <img
              src={imageUrl}
              alt={banner.title}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              style={{ objectPosition: "center 18%" }}
              data-testid="vip-banner-image"
            />
          ) : (
            <div className="h-full w-full bg-gradient-to-br from-coal via-ink to-coal" data-testid="vip-banner-placeholder" />
          )}
          {hasMedia ? (
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
          ) : (
            <div className="absolute inset-0 bg-black/55 transition-colors duration-500 group-hover:bg-black/45" />
          )}
          <div className={`absolute inset-0 flex flex-col px-6 text-center ${hasMedia ? "items-center justify-end pb-8 md:pb-10" : "items-center justify-center"}`}>
            <p className="overline mb-3 flex items-center gap-2 !text-gold" data-testid="vip-banner-overline">
              <Sparkles className="h-4 w-4" strokeWidth={1.5} />
              À la une
            </p>
            <h2
              className="max-w-3xl text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl"
              style={{
                backgroundImage: "linear-gradient(100deg, #4F7DE6 15%, #FF9F42 85%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                filter: "drop-shadow(0 2px 12px rgba(0,0,0,0.9))",
              }}
              data-testid="vip-banner-title"
            >
              {banner.title}
            </h2>
            {!hasMedia && (
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-ivory/75 md:text-base" data-testid="vip-banner-text">
                {banner.text}
              </p>
            )}
            {data && !data.closed && !data.sold_out && (
              <span className="mt-5 inline-flex items-center gap-3 rounded-full bg-copper px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-ivory shadow-lg shadow-copper/30 transition-transform duration-300 group-hover:scale-105" data-testid="vip-banner-cta">
                Réservez ma table VIP
                <ArrowRight className="h-4 w-4" strokeWidth={2} />
              </span>
            )}
            {data?.closed && (
              <span className="mt-5 inline-block rounded-full border border-white/20 bg-black/60 px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-ivory/60" data-testid="vip-banner-closed">
                Réservations clôturées
              </span>
            )}
            {data && !data.closed && data.sold_out && (
              <span className="mt-5 inline-block rounded-full border border-white/20 bg-black/60 px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-ivory/60" data-testid="vip-banner-soldout">
                Les deux tables VIP sont réservées
              </span>
            )}
          </div>
        </div>
      </Link>
    </section>
  );
}
